import React from 'react';
import { useNavigate } from 'react-router-dom';

const ClientInfoCard = ({ client, onAddCase, onAddAgreement }) => {
    const navigate = useNavigate();
    const name = `${client.first_name || ''} ${client.last_name || ''}`.trim();

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">

                    {/* Client Identity */}
                    <div className="flex items-center gap-4">
                        <div className="h-16 w-16 rounded-full bg-gradient-to-br from-blue-600 to-indigo-700 flex items-center justify-center text-2xl font-bold text-white shadow-inner border border-blue-500/30">
                            {name.charAt(0).toUpperCase()}
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-white tracking-tight">{name || client.primary_email || 'Unnamed Client'}</h2>
                            <div className="flex items-center gap-3 text-sm text-gray-400 mt-1">
                                <span className="flex items-center gap-1">
                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                    {client.primary_email || '-'}
                                </span>
                                <span className="w-1 h-1 bg-gray-600 rounded-full"></span>
                                <span className="flex items-center gap-1">
                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                                    {client.primary_phone || '-'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Quick Stats / Info */}
                    <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-4 border-l border-gray-700 pl-6 ml-2">
                        <div>
                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Nationality</div>
                            <div className="font-mono text-white">{client.nationality || '-'}</div>
                        </div>
                        <div>
                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Passport</div>
                            <div className="font-mono text-white">{client.passport_no || '-'}</div>
                        </div>
                        <div>
                            <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Client Since</div>
                            <div className="font-mono text-white">{client.created_at ? new Date(client.created_at).toLocaleDateString() : '-'}</div>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col gap-2 min-w-[140px]">
                        <button onClick={onAddCase} className="px-4 py-2 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 uppercase border border-blue-500 shadow-lg shadow-blue-900/20 transition-all hover:scale-105">
                            + New Case
                        </button>
                        <button onClick={onAddAgreement} className="px-4 py-2 rounded text-xs font-bold bg-gray-700 text-white hover:bg-gray-600 uppercase border border-gray-600 transition-all hover:scale-105">
                            + Agreement
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientInfoCard;
